class ModalCommingSoon extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.init();
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

init() {
  const form = document.getElementById('CommingSoonForm');
  const submitBtn = form.querySelector('.js-comming-soon-submit');
  const emailField = form.querySelector('input[name="contact[email]"]');
  const errorContainer = form.querySelector('#comming-soon-field-email-error');
  if (submitBtn) {
    submitBtn.addEventListener('click', async () => {
      const formData = document.getElementById('CommingSoonForm');
      const company = formData.dataset.company;
      const product = formData.dataset.product;
      submitBtn.disabled = true;
      const userEmailInput = formData.querySelector('input[name="contact[email]"]');
      const userEmail = userEmailInput?.value.trim();
      const submitBlock = formData.querySelector('.contact__submit');
      const dataJetId = formData.dataset.datajetId;
      const productId = formData.dataset.productId;

      if (!userEmail) {
        if (errorContainer) {
          errorContainer.style.display = 'block';
        }
        if (submitBlock) {
          submitBlock.style.marginTop = '20px';
        }
        submitBtn.removeAttribute("disabled");
        return;
      } else if (errorContainer) {
        errorContainer.style.display = 'none';
      }

      let backInStockSuccess = true;
      const emailOptIn =
        document.getElementById('receive-email')?.checked || false;

      const smsOptIn =
        document.getElementById('receive-text')?.checked || false;

      const rawPhone = this.querySelector('#comming-soon-field-phone').value.trim();
      const phoneNumber = '+61' + rawPhone.replace(/^0+/, '');

      await this.updateMarketingConsent({
        email: userEmail,
        phone: phoneNumber,
        emailConsent: emailOptIn,
        smsConsent: smsOptIn,
        dataJetId: dataJetId,
        productId: productId
      });
      await this.trackSubscribedEvent({
        email: userEmail,
        firstName: formData.dataset.customerName ?? 'First Name Not Provided', 
        companyId: company,
        productData: {
          countryCode: Shopify.country ?? 'AU',
          currency: Shopify.currency.active ?? 'AUD',
          name: formData.dataset.productName,
          sku: product,
          handle: formData.dataset.productHandle,
          image: formData.dataset.productMedia,
          url: window.location.href,
          launchDate: formData.dataset.productLaunchDate,
          category: 'Sportstyle',
          brand: 'Salomon',
          productId: productId
        }
      });  
      if (backInStockSuccess) {
        document.querySelector(".form-status-success").style.display = "block";
        document.querySelector(".product-popup-modal__form").style.display = "none";
        document.querySelector(".product-popup-modal__content-info--comming-soon").style.display = "none";
      } else {
        
        document.querySelector(".form-status-error").style.display = "block";
        document.querySelector(".product-popup-modal__form").style.display = "none";
        document.querySelector(".product-popup-modal__content-info--comming-soon").style.display = "none";
      }
      submitBtn.disabled = false;

    });

    if (emailField) {
      emailField.addEventListener('input', () => {
        if (emailField.value.trim() && errorContainer) {
          errorContainer.style.display = 'none';
        }
      });
    }
  }

    const phoneInput = this.querySelector('#comming-soon-field-phone');

    if (phoneInput && !this.itiInstance) {
    this.itiInstance = window.intlTelInput(phoneInput, {
      allowDropdown: true,
      showFlags: true,
      separateDialCode: true,   
      initialCountry: "au",
      formatOnDisplay: true,
      utilsScript:
        "https://cdn.jsdelivr.net/npm/intl-tel-input@18/build/js/utils.js",
    });
    }
  }

  async updateMarketingConsent({
    email,
    phone,
    emailConsent,
    smsConsent,
    dataJetId, productId
  }) {
    try {
      const res = await fetch(
        `/apps/datajet/task/${dataJetId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            email: email,
            phone: phone || null,
            email_subscribed: !!emailConsent,
            sms_subscribed: !!smsConsent,
            product_id: productId
          })
        }
      );

      if (!res.ok) {
        console.error("Consent update failed:", res.status, await res.text());
      } else {
        console.log("✅ Consent updated via App Proxy");
      }

    } catch (err) {
      console.error("Consent error:", err);
    }
  }

    async trackSubscribedEvent({email, firstName, productData, companyId}) {
      try {
        const res = await fetch(`https://a.klaviyo.com/client/events/?company_id=${companyId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2025-01-15'
          },
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      first_name: firstName || '',
                      properties : {
                        Coming_Soon_Product_Id: productData.productId ? [productData.productId] : []
                      }
                    }
                  }
                },
                metric: {
                  data: {
                    type: 'metric',
                    attributes: {
                      name: 'Subscribed to Launch'
                    }
                  }
                },
                properties: {
                  Country_Code: productData.countryCode,
                  Currency: productData.currency,
                  Product_Name: productData.name,
                  Product_SKU: productData.sku,
                  Product_Handle: productData.handle,
                  Product_Image_URL: productData.image,
                  Product_URL: productData.url,
                  Launch_Date: productData.launchDate,
                  Category: productData.category,
                  Brand: productData.brand,
                  Subscription_Source: "Product Page Modal",
                },
                time: new Date().toISOString()
              }
            }
          })
        });

        if (res.status !== 202) {
          console.error('Track event failed:', res.status, await res.text());
        }

      } catch (err) {
        console.error('Track event error:', err);
      }
    }

  show(id_account, variant, product) {
    if (id_account) {
      this.id_account = id_account;
    }
    if (variant) {
      this.variant = variant;
    }
    if (product) {
      this.product = product;
    }
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    document.querySelector('.form-status-success').style.display = 'none';
    document.querySelector('.product-popup-modal__form').style.display = 'block';
    document.querySelector('.form-status-error').style.display = 'none';
    document.querySelector('.contact__button button').removeAttribute('disabled');
    this.removeAttribute('open');
    window.pauseAllMedia();
  }
}
customElements.define('modal-comming-soon', ModalCommingSoon);

class ModalOpenCommingSoon extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    console.log("Opening back-in-stock modal for button:", button);
    if (!button) return;
    button.addEventListener('click', () => {
      if (button && button.getAttribute('aria-disabled') === 'true') {
        const modalContact = document.getElementById(`PopupModalCommingSoon`);
        const id_account = this.dataset.idAccount;
        const variant = this.dataset.variant;
        const product = this.dataset.product;
        if (modalContact) {
          modalContact.show(id_account, variant, product);
        }
        return;
      }
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-open-comming-soon', ModalOpenCommingSoon);

const emailCheckbox = document.getElementById('receive-email');
const emailDesc = document.getElementById('receive-email-desc');

if (emailCheckbox && emailDesc) {
  const toggleDesc = () => {
    emailDesc.style.display = emailCheckbox.checked ? 'block' : 'none';
  };
  toggleDesc();

  emailCheckbox.addEventListener('change', toggleDesc);
}
const phoneCheckbox = document.getElementById('receive-text');
const phoneDesc = document.getElementById('receive-text-desc');

if (phoneCheckbox && phoneDesc) {
  const toggleDesc = () => {
    phoneDesc.style.display = phoneCheckbox.checked ? 'block' : 'none';
  };
  toggleDesc();

  phoneCheckbox.addEventListener('change', toggleDesc);
}